// UTILITY FUNCTIONS ************************************************

// used to get a random whole number between min and max values
function getRandomWholeNumber(min_val, max_val) {
	max_val = Number(max_val) + 1;
	min_val = Number(min_val);
	return ((Math.floor(Math.random() * (max_val - min_val))) + min_val);
}
